import { LANDING_PAGE_PATH, LEGACY_LANDING_PAGE_PATH } from "@/lib/route-paths";

export { LANDING_PAGE_PATH, LEGACY_LANDING_PAGE_PATH };

export function isLandingPagePath(pathname: string): boolean {
  return pathname === LANDING_PAGE_PATH || pathname === LEGACY_LANDING_PAGE_PATH;
}

export function isSeoLandingPagePath(pathname: string): boolean {
  return pathname.startsWith("/shop/");
}
